<template >
  <div class="container-fluid">
    <div v-show="notificationOnly != true" class="row justify-content-end">
      <div class="col-sm-4" v-show="showUsers === true">
        <label class="boldText">Users</label>
        <br />
        <MultiSelect
          class="AuditMultiSelect"
          v-model="selectedUsersId"
          :options="usersList"
          :zindex="1500"
          optionLabel="name"
          placeholder="Search By Status"
          display="chip"
          @change="loadInitNoFilter()"
        />
      </div>
      <div class="col-sm-4" v-show="showSection === true">
        <label class="boldText">Sections</label>
        <br />
        <MultiSelect
          class="AuditMultiSelect"
          v-model="selectedAppModelsId"
          :options="appModelsList"
          optionLabel="name"
          placeholder="Search By Status"
          display="chip"
          @change="loadInitNoFilter()"
        />
      </div>
      <div class="col-sm-4">
        <label class="boldText">Select Date</label>
        <div class="input-group mb-3">
          <input
            type="date"
            class="form-control"
            v-model="filterDate"
            @change="loadInitNoFilter()"
          />
          <div class="input-group-append"></div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" ref="auditLogRef" :style="isItModel()">
            <!-- <button @click="loadInit()">Recall Api</button> -->
            <ul class="timeline timeline-history timeline-margin">
              <li
                v-for="(log, index) in logs"
                :key="index"
                class="timeline-inverted history-li"
              >
                <!-- <h2 style="margin: 30px">{{ log.actionType }}</h2> -->
                <!-- patient checkin Via FormFV -->
                <div
                  v-if="log.actionType == 311 || log.actionType == 401"
                  class="timeline-badge history-badge danger"
                >
                  <i class="fas fa-user"></i>
                </div>
                <div v-else class="timeline-badge history-badge info">
                  <i class="fas fa-user"></i>
                </div>

                <!-- patient checkin Via Form -->
                <div
                  v-if="log.actionType == 311"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                      Checked In on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for visit type/reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                      with visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        | <span style="color: orangered"></span>
                        {{ log.appModelName }}</small
                      >
                    </p>
                  </div>
                </div>
                <!-- patient checkin Via Quick Form -->
                <div
                  v-if="log.actionType == 312"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      Checked In
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      assigned visit ID
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      for visit type/reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered">{{
                          log.appModelName
                        }}</span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- patient checkin Via Quick Form -->
                <!-- patient Create New Patient Mapping -->

                <div
                  v-else-if="log.actionType == 201"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      created a new profile for patient
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                      to
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered">{{
                          log.appModelName
                        }}</span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- patient Create New Patient Mapping -->
                <!-- patient Merge with Current Patient Mapping -->
                <div
                  v-else-if="log.actionType == 200"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned patient
                      <span class="font-weight-bold text-danger">{{
                        log.detailTextString
                      }}</span>
                      to
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered">{{
                          log.appModelName
                        }}</span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 202"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      merged patient profile
                      <span class="font-weight-bold text-danger">{{
                        log.detailTextString
                      }}</span>
                      to
                      <span class="font-weight-bold text-danger"
                        >{{ log.ptId }}
                        -
                        {{ log.patientName }}</span
                      >
                      for
                      <span class="font-weight-bold text-success"
                        >Visit ID:{{ log.vid }}</span
                      >
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered">{{
                          log.appModelName
                        }}</span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- patient Merge with Current Patient Mapping -->
                <!-- PhysicianAssigned -->
                <div
                  v-else-if="log.actionType == 302"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned physician
                      <span class="font-weight-bold text-warning">{{
                        log.physicianName
                      }}</span>
                      to patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered">{{
                          log.appModelName
                        }}</span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- PhysicianAssigned -->
                <!-- PhysicianAssigned -->
                <div
                  v-else-if="log.actionType == 303"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      re-assigned physician
                      <span class="font-weight-bold text-warning">{{
                        log.physicianName
                      }}</span>
                      to patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered">{{
                          log.appModelName
                        }}</span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- PhysicianAssigned -->

                <!-- started step  -->
                <div
                  v-else-if="log.actionType == 403"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      started step
                      <span class="font-weight-bold text-cyan">{{
                        log.stepName
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered">{{
                          log.appModelName
                        }}</span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- started step  -->

                <!-- started Close  -->
                <div
                  v-else-if="log.actionType == 404"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      completed step
                      <span class="font-weight-bold text-cyan">{{
                        log.stepName
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered">{{
                          log.appModelName
                        }}</span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- started Close  -->

                <!-- restarted step  -->

                <div
                  v-else-if="log.actionType == 405"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      re-started step
                      <span class="font-weight-bold text-cyan">{{
                        log.stepName
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered">{{
                          log.appModelName
                        }}</span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- Restarted step  -->
                <!-- step deleted -->
                <div
                  v-else-if="log.actionType == 406"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      canceled step
                      <span class="font-weight-bold text-cyan">{{
                        log.stepName
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }} - {{}}</span
                        >
                      </small>
                    </p>
                  </div>
                </div>
                <!-- step deleted -->
                <!-- step Add -->
                <div
                  v-else-if="log.actionType == 450"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      added step
                      <span class="font-weight-bold text-cyan">{{
                        log.stepName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }} - {{}}</span
                        >
                      </small>
                    </p>
                  </div>
                </div>
                <!-- step add -->
                <!-- step archive -->
                <div
                  v-else-if="log.actionType == 451"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      archived step
                      <span class="font-weight-bold text-cyan">{{
                        log.stepName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }} - {{}}</span
                        >
                      </small>
                    </p>
                  </div>
                </div>
                <!-- step active -->
                <div
                  v-else-if="log.actionType == 452"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      activated step
                      <span class="font-weight-bold text-cyan">{{
                        log.stepName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }} - {{}}</span
                        >
                      </small>
                    </p>
                  </div>
                </div>
                <!-- step ac -->
                <!-- Stage Initial -->

                <div
                  v-else-if="log.actionType == 401"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <!-- <span v-if="log.ptId!==null" class="font-weight-bold text-danger">{{log.ptId}} - </span> -->
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                      entered initial stage
                      <span class="font-weight-bold text-cyan">{{
                        log.stageName
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered">{{
                          log.appModelName
                        }}</span>
                      </small>
                    </p>
                  </div>
                </div>

                <!-- Stage Initial -->
                <!-- Stage Change -->
                <div
                  v-else-if="log.actionType == 1"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      moved visit
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      from stage
                      <span class="font-weight-bold text-cyan">{{
                        log.stageName
                      }}</span>
                      to
                      <span class="font-weight-bold text-cyan">check out</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>

                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 2"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      moved visit
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      from stage
                      <span class="font-weight-bold text-cyan">check out</span>
                      to
                      <span class="font-weight-bold text-cyan">{{
                        log.stageName
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>

                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 402"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      moved visit
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      from stage
                      <span class="font-weight-bold text-cyan">{{
                        log.detailTextString
                      }}</span>
                      to
                      <span class="font-weight-bold text-cyan">{{
                        log.stageName
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>

                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- Stage Change -->
                <!-- Stage add -->

                <div
                  v-else-if="log.actionType == 407"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      added stage
                      <span class="font-weight-bold text-cyan">{{
                        log.stageName
                      }}</span>
                    </p>

                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- Stage add -->
                <!-- Stage archive -->

                <div
                  v-else-if="log.actionType == 408"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      archived stage
                      <span class="font-weight-bold text-cyan">{{
                        log.stageName
                      }}</span>
                    </p>

                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- Stage archive -->
                <!--   payment request credidt card  -->
                <div
                  v-else-if="log.actionType == 301"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      sent payment request
                      <span class="font-weight-bold text-payment">{{
                        "PYI" + log.paymentId
                      }}</span>
                      for
                      <span class="font-weight-bold text-payment"
                        >${{ log.requestAmount }}</span
                      >
                      to
                      <span class="font-weight-bold text-communication">{{
                        log.requestPayEmail
                      }}</span>
                      and
                      <span class="font-weight-bold text-communication"
                        >+{{ log.requestPayPhone }}</span
                      >
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>

                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- payment delete -->
                <div
                  v-else-if="log.actionType == 309"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      deleted payment request
                      <span class="font-weight-bold text-payment">{{
                        "PYI" + log.paymentId
                      }}</span>
                      for
                      <span class="font-weight-bold text-payment"
                        >${{ log.requestAmount }}</span
                      >
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>

                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- Payment Reminder -->
                <div
                  v-else-if="log.actionType == 306"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      sent payment reminder
                      <span class="font-weight-bold text-payment">{{
                        "PYI" + log.paymentId
                      }}</span>
                      for
                      <span class="font-weight-bold text-payment"
                        >${{ log.requestAmount }}</span
                      >
                      to
                      <span class="font-weight-bold text-communication">{{
                        log.reminderPayEmail
                      }}</span>
                      and
                      <span class="font-weight-bold text-communication"
                        >+{{ log.reminderPayPhone }}</span
                      >
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>

                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!--sent payment receipt -->
                <div
                  v-else-if="log.actionType == 313"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      sent payment receipt
                      <span class="font-weight-bold text-payment">{{
                        "PYI" + log.paymentId
                      }}</span>
                      for
                      <span class="font-weight-bold text-payment"
                        >${{ log.requestAmount }}</span
                      >
                      to
                      <span class="font-weight-bold text-communication">{{
                        log.requestPayEmail
                      }}</span>
                      and
                      <span class="font-weight-bold text-communication"
                        >+{{ log.requestPayPhone }}</span
                      >
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>

                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!--sent payment receipt -->
                <div
                  v-else-if="log.actionType == 314"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      reconciled payment
                      <span class="font-weight-bold text-payment">{{
                        "PYI" + log.paymentId
                      }}</span>
                      for
                      <span class="font-weight-bold text-payment"
                        >${{ log.requestAmount }}</span
                      >
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>

                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 316"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      Trigger for
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                      assigned physician
                      <span class="font-weight-bold text-communication">{{
                        log.userName
                      }}</span>
                      for Visit ID
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 317"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      Deleted
                      <span class="font-weight-bold text-danger">{{
                        log.detailTextString
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!--   payment Collect credidt card  -->
                <div
                  v-else-if="log.actionType == 300"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      collected payment request
                      <span class="font-weight-bold text-payment">{{
                        "PYI" + log.paymentId
                      }}</span>
                      for
                      <span class="font-weight-bold text-payment"
                        >${{ log.receivedAmount }}</span
                      >
                      <span v-if="log.paymentMethod == 1">
                        via Credit/Debit Card
                      </span>
                      <span v-if="log.paymentMethod == 2"> via Cash </span>
                      <span v-if="log.paymentMethod == 3"> via Cheque </span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>

                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 315"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      Payment Made
                      <span class="font-weight-bold text-payment"
                        >Payment ID {{ "PYI" + log.paymentId }}</span
                      >
                      for
                      <span class="font-weight-bold text-payment"
                        >${{ log.requestAmount }}</span
                      >
                      via payment portal for Visit ID:
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- Payment Refund -->
                <div
                  v-else-if="log.actionType == 310"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      refunded payment request
                      <span class="font-weight-bold text-payment">{{
                        "PYI" + log.paymentId
                      }}</span>
                      for
                      <span class="font-weight-bold text-payment"
                        >${{ log.refundAmount }}</span
                      >
                      via
                      <span v-if="log.paymentMethod == 1">
                        via Credit/Debit Card
                      </span>
                      <span v-if="log.paymentMethod == 2"> Cash </span>
                      <span v-if="log.paymentMethod == 3"> Cheque </span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- Location Edit -->
                <div
                  v-else-if="log.actionType == 1000"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated location info
                      <span class="font-weight-bold text-task">{{
                        log.fieldName
                      }}</span>
                      from
                      <span class="font-weight-bold text-data">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-data">{{
                        log.detailTextString
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- Physician Active -->
                <div
                  v-else-if="log.actionType == 1001"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      activated physician
                      <span class="font-weight-bold text-warning">{{
                        log.physicianName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- Physician  InActive-->
                <div
                  v-else-if="log.actionType == 1002"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      de-activated physician
                      <span class="font-weight-bold text-warning">{{
                        log.physicianName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- Visit Type  Added-->
                <div
                  v-else-if="log.actionType == 2000"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      added visit type
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- Visit Type  archive-->
                <div
                  v-else-if="log.actionType == 2001"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      archived visit type
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- Add Demo -->
                <div
                  v-else-if="log.actionType == 3000"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      created a demo question
                      <span class="font-weight-bold text-demo">{{
                        "DID-" + log.demoQuestIdIdSerial
                      }}</span>
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.question
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- Add Question -->
                <div
                  v-else-if="log.actionType == 4000"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      created a Questionnaire question
                      <span class="font-weight-bold text-question">{{
                        "QID" + log.demoQuestIdIdSerial
                      }}</span>
                      -
                      <span class="font-weight-bold text-question">{{
                        log.question
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- Archive Demo -->
                <div
                  v-else-if="log.actionType == 3002"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      archived a demo question
                      <span class="font-weight-bold text-demo">{{
                        "DID" + log.demoQuestIdIdSerial
                      }}</span>
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.question
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- Archive Questionnaire -->
                <div
                  v-else-if="log.actionType == 4002"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      archived a Questionnaire question
                      <span class="font-weight-bold text-question">{{
                        "QID" + log.demoQuestIdIdSerial
                      }}</span>
                      -
                      <span class="font-weight-bold text-question">{{
                        log.question
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- updated a demo-->
                <!-- updated a Questionnaire-->
                <div
                  v-else-if="log.actionType == 3001"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated a Demo question
                      <span class="font-weight-bold text-demo">{{
                        "DID" + log.demoQuestIdIdSerial
                      }}</span>
                      <!-- -  
                                                    <span class="font-weight-bold text-demo">{{log.questName}}</span> -->
                      from
                      <span class="font-weight-bold text-value">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-value">{{
                        log.detailTextString
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 4001"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated a questionnaire question
                      <span class="font-weight-bold text-question">{{
                        "QID" + log.demoQuestIdIdSerial
                      }}</span>
                      <!-- -  
                                                    <span class="font-weight-bold text-question">{{log.questName }}</span> -->
                      from
                      <span class="font-weight-bold text-value">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-value">{{
                        log.detailTextString
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 4004"
                  class="timeline-panel history-panel"
                >
                  <p>
                    <span class="font-weight-bold text-info">{{
                      log.userName
                    }}</span>
                    updated questionnaire response for
                    <span class="font-weight-bold text-question"
                      >QID-{{ log.demoQuestIdIdSerial }}</span
                    >
                    -
                    <span class="font-weight-bold text-question">{{
                      log.question
                    }}</span>
                    from
                    <span class="font-weight-bold text-response">{{
                      log.oldData
                    }}</span>
                    to
                    <span class="font-weight-bold text-response">{{
                      log.detailTextString
                    }}</span>
                    for visit id
                    <span class="font-weight-bold text-success">{{
                      log.vid
                    }}</span>
                    on DOS
                    <span class="font-weight-bold text-purple">{{
                      log.dosStr
                    }}</span>
                    for patient
                    <span class="font-weight-bold text-danger">{{
                      log.ptId
                    }}</span>
                    -
                    <span class="font-weight-bold text-danger">{{
                      log.patientName
                    }}</span>
                  </p>
                  <p>
                    <small style="color: grey" class="mt-2"
                      >{{ log.dateLocalStr }} |
                      <span style="color: orangered">{{
                        log.practiceName
                      }}</span>
                      |
                      <span style="color: orangered"
                        >{{ log.appModelName }}
                      </span>
                    </small>
                  </p>
                </div>
                <div
                  v-else-if="log.actionType == 3004"
                  class="timeline-panel history-panel"
                >
                  <p>
                    <span class="font-weight-bold text-info">{{
                      log.userName
                    }}</span>
                    updated custom demo for
                    <span class="font-weight-bold text-question"
                      >DID-{{ log.demoQuestIdIdSerial }}</span
                    >
                    -
                    <span class="font-weight-bold text-question">{{
                      log.question
                    }}</span>
                    from
                    <span class="font-weight-bold text-response">{{
                      log.oldData
                    }}</span>
                    to
                    <span class="font-weight-bold text-response">{{
                      log.detailTextString
                    }}</span>
                    for visit id
                    <span class="font-weight-bold text-success">{{
                      log.vid
                    }}</span>
                    on DOS
                    <span class="font-weight-bold text-purple">{{
                      log.dosStr
                    }}</span>
                    for patient
                    <span class="font-weight-bold text-danger">{{
                      log.ptId
                    }}</span>
                    -
                    <span class="font-weight-bold text-danger">{{
                      log.patientName
                    }}</span>
                  </p>
                  <p>
                    <small style="color: grey" class="mt-2"
                      >{{ log.dateLocalStr }} |
                      <span style="color: orangered">{{
                        log.practiceName
                      }}</span>
                      |
                      <span style="color: orangered"
                        >{{ log.appModelName }}
                      </span>
                    </small>
                  </p>
                </div>
                <!-- AddTask -->
                <div
                  v-else-if="log.actionType == 5000"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      added task
                      <span class="font-weight-bold text-task"
                        >TID-{{ log.taskCode }}</span
                      >
                      -
                      <span class="font-weight-bold text-task">{{
                        log.taskName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 5001"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body" v-if="log.vid == ''">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated task
                      <span class="font-weight-bold text-task">TID-{{
                        log.tid
                      }}</span>
                      -
                      <span class="font-weight-bold text-task">{{
                        log.taskName
                      }}</span>
                      for
                      <span class="font-weight-bold text-task">{{
                        log.fieldName
                      }}</span>
                      from
                      <span class="font-weight-bold text-data">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-data">{{
                        log.detailTextString
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                  <div class="timeline-body" v-else>
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated task
                      <span class="font-weight-bold text-task">TID-{{
                        log.tid
                      }}</span>
                      -
                      <span class="font-weight-bold text-task">{{
                        log.taskName
                      }}</span>
                      for
                      <span class="font-weight-bold text-task">{{
                        log.fieldName
                      }}</span>
                      from
                      <span class="font-weight-bold text-data">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-data">{{
                        log.detailTextString
                      }}</span>
                      for Visit ID
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span> - 
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 5002"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body" v-if="log.ptId">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      deleted task
                      <span class="font-weight-bold text-task"
                        >TID-{{ log.tid }}</span
                      >
                      -
                      <span class="font-weight-bold text-task">{{
                        log.taskName
                      }}</span>
                      for visit Id
                      <span class="font-weight-bold text-success">
                        {{ log.vid }}</span
                      >
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger"
                        >{{ log.ptId }}</span
                      >
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                  <div class="timeline-body" v-else>
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      deleted task
                      <span class="font-weight-bold text-task"
                        >TID-{{ log.tid }}</span
                      >
                      -
                      <span class="font-weight-bold text-task">{{
                        log.taskName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- TaskAssign -->
                <div
                  v-else-if="log.actionType == 5004"
                  class="timeline-panel history-panel"
                >
                  <div v-if="log.ptId == 0" class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned task task id
                      <span class="font-weight-bold text-task"
                        >TID-{{ log.tid }}</span
                      >
                      -
                      <span class="font-weight-bold text-task">{{
                        log.detailTextString
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                  <div v-else class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned task task id
                      <span class="font-weight-bold text-task"
                        >TID-{{ log.tid }}</span
                      >
                      -
                      <span class="font-weight-bold text-task">{{
                        log.detailTextString
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">
                        {{ log.vid }}</span
                      >
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">
                        {{ log.ptId }}</span
                      >
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- TaskUnassign -->
                <div
                  v-else-if="log.actionType == 5005"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      un-assigned task task id
                      <span class="font-weight-bold text-task"
                        >TID-{{ log.taskCode }}</span
                      >
                      -
                      <span class="font-weight-bold text-task">{{
                        log.taskName
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">
                        {{ log.vid }}</span
                      >
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">
                        {{ log.ptId }}</span
                      >
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- TaskMarkCompleted -->
                <div
                  v-else-if="log.actionType == 5006"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      completed task task id
                      <span class="font-weight-bold text-task"
                        >TID-{{ log.taskCode }}</span
                      >
                      -
                      <span class="font-weight-bold text-task">{{
                        log.taskName
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 5009"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      Trigger for
                      <span class="font-weight-bold text-cyan">{{
                        log.stageName
                      }}</span>
                      assigned task
                      <span class="font-weight-bold text-task"
                        >{{ log.tid }}</span
                      >
                      -
                      <span class="font-weight-bold text-task">{{
                        log.taskName
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 5007"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      Trigger for
                      <span class="font-weight-bold text-cyan"
                        >{{ log.stageName }}-{{ log.stepName }}</span
                      >
                      assigned task
                      <span class="font-weight-bold text-task"
                        >{{ log.tid }}</span
                      >
                      -
                      <span class="font-weight-bold text-task">{{
                        log.taskName
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 5008"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      Trigger for
                      <span class="font-weight-bold text-cyan"
                        >{{ log.visitType }}-{{ log.reason }}</span
                      >
                      assigned task
                      <span class="font-weight-bold text-task"
                        >{{ log.tid }}</span
                      >
                      -
                      <span class="font-weight-bold text-task">{{
                        log.taskName
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>

                <div
                  v-else-if="log.actionType == 6000"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      submitted for approval email template
                      <span class="font-weight-bold text-communication">{{
                        "EID-" + log.emailTempIdSerial
                      }}</span>
                      -
                      <span class="font-weight-bold text-communication">{{
                        log.emailTempName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 6002"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      deleted email template
                      <span class="font-weight-bold text-communication">{{
                        "EID-" + log.emailTempIdSerial
                      }}</span>
                      -
                      <span class="font-weight-bold text-communication">{{
                        log.emailTempName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 6003"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      saved draft email template
                      <span class="font-weight-bold text-communication">{{
                        "EID-" + log.emailTempIdSerial
                      }}</span>
                      -
                      <span class="font-weight-bold text-communication">{{
                        log.emailTempName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- Send Email trigger step -->
                <div
                  v-else-if="
                    log.actionType == EnumActionTypes.EmailSendTriggerStep
                  "
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      Trigger for
                      <span class="font-weight-bold text-success">{{
                        log.stageName
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.stepName
                      }}</span>
                      sent email
                      <span
                        class="font-weight-bold text-communication"
                        v-html="log.detailTextString"
                      ></span>
                      to
                      <span class="font-weight-bold text-communication">{{
                        log.oldData
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <small style="color: grey" class="mt-2"
                      >{{ log.dateLocalStr }} |
                      <span style="color: orangered">{{
                        log.practiceName
                      }}</span>
                      |
                      <span style="color: orangered"
                        >{{ log.appModelName }}
                      </span>
                    </small>
                  </div>
                </div>
                <!-- Send Email trigger Stage -->
                <div
                  v-else-if="
                    log.actionType == EnumActionTypes.EmailSendTriggerStage
                  "
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      Trigger for
                      <span class="font-weight-bold text-success">{{
                        log.stageName
                      }}</span>
                      sent email
                      <span
                        class="font-weight-bold text-communication"
                        v-html="log.detailTextString"
                      ></span>
                      to
                      <span class="font-weight-bold text-communication">{{
                        log.oldData
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <small style="color: grey" class="mt-2"
                      >{{ log.dateLocalStr }} |
                      <span style="color: orangered">{{
                        log.practiceName
                      }}</span>
                      |
                      <span style="color: orangered"
                        >{{ log.appModelName }}
                      </span>
                    </small>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 6006"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      Trigger for
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                      sent email
                      <span
                        class="font-weight-bold text-communication"
                        v-html="log.detailTextString"
                      ></span>
                      to
                      <span class="font-weight-bold text-communication">{{
                        log.oldData
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <small style="color: grey" class="mt-2"
                      >{{ log.dateLocalStr }} |
                      <span style="color: orangered">{{
                        log.practiceName
                      }}</span>
                      |
                      <span style="color: orangered"
                        >{{ log.appModelName }}
                      </span>
                    </small>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 7000"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      submitted for approval sms template
                      <span class="font-weight-bold text-communication">{{
                        "SMST-" + log.smsTempIdSerial
                      }}</span>
                      -
                      <span class="font-weight-bold text-communication">{{
                        log.smsTempName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 7001"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      Updated and Submited for approval sms template
                      <span class="font-weight-bold text-communication">{{
                        "SMST-" + log.smsTempIdSerial
                      }}</span>
                      -
                      <span class="font-weight-bold text-communication">{{
                        log.smsTempName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 7002"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      deleted sms template
                      <span class="font-weight-bold text-communication">{{
                        "SMST-" + log.smsTempIdSerial
                      }}</span>
                      -
                      <span class="font-weight-bold text-communication">{{
                        log.smsTempName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 7003"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      saved draft sms template
                      <span class="font-weight-bold text-communication">{{
                        "SMST-" + log.smsTempIdSerial
                      }}</span>
                      -
                      <span class="font-weight-bold text-communication">{{
                        log.smsTempName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- Sms trigger send message -->
                <div
                  v-else-if="log.actionType == 7004"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      Trigger for
                      <span class="font-weight-bold text-success">{{
                        log.stageName
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.stepName
                      }}</span>
                      sent sms
                      <span
                        class="font-weight-bold text-communication"
                        v-html="log.detailTextString"
                      ></span>
                      to
                      <span class="font-weight-bold text-communication"
                        >+{{ log.oldData }}</span
                      >
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <small style="color: grey" class="mt-2"
                      >{{ log.dateLocalStr }} |
                      <span style="color: orangered">{{
                        log.practiceName
                      }}</span>
                      |
                      <span style="color: orangered"
                        >{{ log.appModelName }}
                      </span>
                    </small>
                  </div>
                </div>
                <!-- Sms trigger send message -->
                <div
                  v-else-if="
                    log.actionType == EnumActionTypes.SmsSendTriggerStage
                  "
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      Trigger for
                      <span class="font-weight-bold text-success">{{
                        log.stageName
                      }}</span>
                      sent sms
                      <span
                        class="font-weight-bold text-communication"
                        v-html="log.detailTextString"
                      ></span>
                      to
                      <span class="font-weight-bold text-communication"
                        >+{{ log.oldData }}</span
                      >
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <small style="color: grey" class="mt-2"
                      >{{ log.dateLocalStr }} |
                      <span style="color: orangered">{{
                        log.practiceName
                      }}</span>
                      |
                      <span style="color: orangered"
                        >{{ log.appModelName }}
                      </span>
                    </small>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 7006"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      Trigger for
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                      sent sms
                      <span
                        class="font-weight-bold text-communication"
                        v-html="log.detailTextString"
                      ></span>
                      to
                      <span class="font-weight-bold text-communication">{{
                        log.oldData
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span
                        v-if="log.ptId !== ''"
                        class="font-weight-bold text-danger"
                        >{{ log.ptId }}-</span
                      >
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <small style="color: grey" class="mt-2"
                      >{{ log.dateLocalStr }} |
                      <span style="color: orangered">{{
                        log.practiceName
                      }}</span>
                      |
                      <span style="color: orangered"
                        >{{ log.appModelName }}
                      </span>
                    </small>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 8000"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      added resource
                      <span class="font-weight-bold text-resource"
                        >R{{ log.resourceIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-resource">{{
                        log.resourceName
                      }}</span>
                      with total quantity
                      <span class="font-weight-bold text-total">{{
                        log.resourceQty
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 8001"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated resource
                      <span class="font-weight-bold text-resource"
                        >R{{ log.resourceIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-resource">{{
                        log.resourceName
                      }}</span>
                      field
                      <span class="font-weight-bold text-task">{{
                        log.fieldName
                      }}</span>
                      from
                      <span class="font-weight-bold text-value">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-value">{{
                        log.detailTextString
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 8002"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      archived resource
                      <span class="font-weight-bold text-resource"
                        >R{{ log.resourceIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-resource">{{
                        log.resourceName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- <div v-else-if="log.actionType==8003" class="timeline-panel history-panel">
                                            <div class="timeline-body">
                                              <p>
                                                <span class="font-weight-bold text-info">{{log.userName}}</span> 
                                                Resource Assign
                                                <span class="font-weight-bold text-question">{{'QID'+ log.demoQuestIdIdSerial}}</span>
                                                -  
                                                <span class="font-weight-bold text-question">{{log.questName }}</span>
                                             </p>
                                              <p><small style="color:grey;" class="mt-2">{{log.dateLocalStr}} | <span style="color:orangered">{{log.practiceName}}</span> | <span style="color:orangered">{{log.appModelName}} </span> </small></p>
                                            </div>            
                                        </div> -->
                <div
                  v-else-if="
                    log.actionType == EnumActionTypes.ResourceReleaseStep
                  "
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      Trigger for
                      <span class="font-weight-bold text-cyan">{{
                        log.stageName + "-" + log.stepName
                      }}</span>
                      release resource
                      <span class="font-weight-bold text-resource"
                        >R{{ log.resourceIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-resource">{{
                        log.resourceName
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="
                    log.actionType == EnumActionTypes.ResourceReleaseStage
                  "
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      Trigger for
                      <span class="font-weight-bold text-cyan">{{
                        log.stageName
                      }}</span>
                      release resource
                      <span class="font-weight-bold text-resource"
                        >R{{ log.resourceIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-resource">{{
                        log.resourceName
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="
                    log.actionType == EnumActionTypes.ResourceCaptureStep
                  "
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      Trigger for
                      <span class="font-weight-bold text-cyan">{{
                        log.stageName + "-" + log.stepName
                      }}</span>
                      capture resource
                      <span class="font-weight-bold text-resource"
                        >R{{ log.resourceIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-resource">{{
                        log.resourceName
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="
                    log.actionType == EnumActionTypes.ResourceCaptureStage
                  "
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      Trigger for
                      <span class="font-weight-bold text-cyan">{{
                        log.stageName
                      }}</span>
                      assigned resource
                      <span class="font-weight-bold text-resource"
                        >R{{ log.resourceIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-resource">{{
                        log.resourceName
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 8009"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      Trigger for
                      <span class="font-weight-bold text-cyan">{{
                        log.stageName
                      }}</span>
                      assigned resource
                      <span class="font-weight-bold text-resource"
                        >R{{ log.resourceIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-resource">{{
                        log.resourceName
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <!-- <span class="font-weight-bold text-danger">{{log.ptId}}</span> 
                                                     -->
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- smsTemplate -->
                <div
                  v-else-if="log.actionType == EnumActionTypes.TextSent"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      sent sms
                      <!-- <span class="font-weight-bold text-communication"> SMST-{{log.smsTempIdSerial}}</span>
                                                    -
                                                    <span class="font-weight-bold text-communication">{{log.smsTempName}}</span> -->
                      <span
                        class="font-weight-bold text-communication"
                        v-html="log.oldData"
                      ></span>
                      to
                      <span class="font-weight-bold text-communication">{{
                        log.detailTextString
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">
                        {{ log.ptId }}</span
                      >
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- EmailTemplate -->
                <div
                  v-else-if="log.actionType == 51"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      sent email
                      <!-- <span class="font-weight-bold text-communication"> EID-{{log.emailTempIdSerial}}</span>
                                                    -
                                                    <span class="font-weight-bold text-communication">{{log.emailTempName}}</span> -->
                      <span
                        class="font-weight-bold text-communication"
                        v-html="log.oldData"
                      ></span>
                      to
                      <span class="font-weight-bold text-communication">{{
                        log.detailTextString
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- CommentsId -->
                <div
                  v-else-if="log.actionType == 100"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      left comment
                      <span class="font-weight-bold text-comment">{{
                        log.detailTextString
                      }}</span>
                      for
                      <span class="font-weight-bold text-success"
                        >Visit ID:{{ log.vid }}</span
                      >
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for
                      <span class="font-weight-bold text-danger"
                        >patient {{ log.ptId }}</span
                      >
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 999"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      started upload to patient table via CSV
                      <span class="font-weight-bold text-file">{{
                        log.detailTextString
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- VisitType page -->
                <div
                  v-else-if="log.actionType == 600"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated visit type name from
                      <span class="font-weight-bold text-success">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-success">{{
                        log.detailTextString
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 601"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated visit reason name from
                      <span class="font-weight-bold text-success"
                        >{{ log.visitType }}-{{ log.oldData }}</span
                      >
                      to
                      <span class="font-weight-bold text-success"
                        >{{ log.visitType }}-{{ log.detailTextString }}</span
                      >
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 602"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned questionnaire
                      <span class="font-weight-bold text-question"
                        >QID-{{ log.demoQuestIdIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-question">{{
                        log.question
                      }}</span>
                      to visit type/reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 603"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned demo question
                      <span class="font-weight-bold text-question"
                        >DID-{{ log.demoQuestIdIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-question">{{
                        log.question
                      }}</span>
                      to visit type/reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 604"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned task
                      <span class="font-weight-bold text-question"
                        >TID-{{ log.taskCode }}</span
                      >
                      -
                      <span class="font-weight-bold text-question">{{
                        log.taskName
                      }}</span>
                      to visit type/reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 605"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned sms template
                      <span class="font-weight-bold text-question"
                        >SMST-{{ "0" + log.smsTempIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-question">{{
                        log.smsTempName
                      }}</span>
                      to visit type/reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 606"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned Email template
                      <span class="font-weight-bold text-question"
                        >EID-{{ log.emailTempIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-question">{{
                        log.emailTempName
                      }}</span>
                      to visit type/reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 607"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated order of Visit type
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      from
                      <span class="font-weight-bold text-order"
                        >order id {{ log.oldData }}</span
                      >
                      to
                      <span class="font-weight-bold text-order"
                        >order id {{ log.detailTextString }}</span
                      >
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 608"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      added Visit Reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span
                      >-
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 609"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      archived Visit Reason
                      <span class="font-weight-bold text-success"
                        >{{ log.visitType }}-{{ log.reason }}</span
                      >
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 610"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      activated Visit Reason
                      <span class="font-weight-bold text-success"
                        >{{ log.visitType }}-{{ log.reason }}</span
                      >
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 611"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated order of Visit Reason
                      <span class="font-weight-bold text-success"
                        >{{ log.visitType }}-{{ log.reason }}</span
                      >
                      from
                      <span class="font-weight-bold text-order"
                        >order id {{ log.oldData }}</span
                      >
                      to
                      <span class="font-weight-bold text-order"
                        >order id {{ log.detailTextString }}</span
                      >
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 612"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      un-assigned Questionnaire question
                      <span class="font-weight-bold text-question"
                        >QID-{{ log.demoQuestIdIdSerial }}-{{
                          log.question
                        }}</span
                      >
                      to visit type/reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span
                      >-<span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 613"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      un-assigned Demo question
                      <span class="font-weight-bold text-question"
                        >DID-{{ log.demoQuestIdIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-question">{{
                        log.question
                      }}</span>
                      to visit type/reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 614"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      un-assigned Task
                      <span class="font-weight-bold text-question"
                        >TID-{{ log.taskCode }}</span
                      >
                      -
                      <span class="font-weight-bold text-question">{{
                        log.taskName
                      }}</span>
                      to visit type/reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>

                <div
                  v-else-if="log.actionType == 615"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      un-assigned sms Template
                      <span class="font-weight-bold text-question"
                        >SMST-{{ "0" + log.smsTempIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-question">{{
                        log.smsTempName
                      }}</span>
                      to visit type/reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 616"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      un-assigned email Template
                      <span class="font-weight-bold text-question"
                        >EID-{{ log.emailTempIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-question">{{
                        log.emailTempName
                      }}</span>
                      to visit type/reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 617"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned physician
                      <span class="font-weight-bold text-question">{{
                        log.physicianName
                      }}</span>
                      to visit type/reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 618"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated visit type from
                      <span class="font-weight-bold text-success">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-success">{{
                        log.detailTextString
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosNoTime
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 619"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated visit reason from
                      <span class="font-weight-bold text-success">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-success">{{
                        log.detailTextString
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosNoTime
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 620"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated date of service from
                      <span class="font-weight-bold text-success">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-success">{{
                        log.detailTextString
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosNoTime
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 627"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated appointment time
                      <span class="font-weight-bold text-success">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-success">{{
                        log.detailTextString
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 628"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated Group for
                      <span class="font-weight-bold text-success">{{
                        log.detailTextString
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      for DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 621"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated order of demo question
                      <span class="font-weight-bold text-demo"
                        >DID-{{ log.demoQuestIdIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-question">{{
                        log.question
                      }}</span>
                      from
                      <span class="font-weight-bold text-order">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-order">{{
                        log.detailTextString
                      }}</span>
                      for visit type/reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 622"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated order of questionnaire question
                      <span class="font-weight-bold text-demo"
                        >QID-{{ log.demoQuestIdIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-question">{{
                        log.question
                      }}</span>
                      from
                      <span class="font-weight-bold text-order">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-order">{{
                        log.detailTextString
                      }}</span>
                      for visit type/reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 623"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned questionnaire question
                      <span class="font-weight-bold text-question"
                        >QID-{{ log.demoQuestIdIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-question">{{
                        log.question
                      }}</span>
                      as required for visit type/reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 624"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned questionnaire question
                      <span class="font-weight-bold text-question"
                        >QID-{{ log.demoQuestIdIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-question">{{
                        log.question
                      }}</span>
                      as un-required for visit type/reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 625"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned demo question
                      <span class="font-weight-bold text-question"
                        >DID-{{ log.demoQuestIdIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-question">{{
                        log.question
                      }}</span>
                      as required for visit type/reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 626"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned demo question
                      <span class="font-weight-bold text-question"
                        >DID-{{ log.demoQuestIdIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-question">{{
                        log.question
                      }}</span>
                      as un-required for visit type/reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- demo is Activated -->
                <div
                  v-else-if="log.actionType == EnumActionTypes.DemoActive"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      activated a Demo question
                      <span class="font-weight-bold text-demo">{{
                        "DID" + log.demoQuestIdIdSerial
                      }}</span>
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.question
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>

                <div
                  v-else-if="
                    log.actionType == EnumActionTypes.QuestionnaireActive
                  "
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      activated a questionnaire question
                      <span class="font-weight-bold text-demo">{{
                        "QID" + log.demoQuestIdIdSerial
                      }}</span>
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.question
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- Patient Display active -->
                <div
                  v-else-if="
                    log.actionType == EnumActionTypes.InactivePatientDelete
                  "
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      deleted in-active visit record Visit ID:
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                      with visit type/reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="
                    log.actionType == EnumActionTypes.ActivePatientDelete
                  "
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      deleted active visit record Visit ID:
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for
                      <span class="font-weight-bold text-danger">
                        {{ log.ptId }} </span
                      >-
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                      with visit type/reason
                      <span class="font-weight-bold text-success">{{
                        log.visitType
                      }}</span>
                      -
                      <span class="font-weight-bold text-success">{{
                        log.reason
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == EnumActionTypes.CustomDemoUpdate"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info"
                        >Shakir Ansari</span
                      >
                      updated custom demo for
                      <span class="font-weight-bold text-demo">DID 01</span>
                      -
                      <span class="font-weight-bold text-demo"
                        >How are you feeling?</span
                      >
                      from
                      <span class="font-weight-bold text-response">fine</span>
                      to
                      <span class="font-weight-bold text-response">bad</span>
                      for
                      <span class="font-weight-bold text-danger">PT02</span>
                      -
                      <span class="font-weight-bold text-danger">Jenifer</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 320"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated insurance information
                      <span class="font-weight-bold text-danger">{{
                        log.fieldName
                      }}</span>
                      from
                      <span class="font-weight-bold text-data">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-data">{{
                        log.detailTextString
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="
                    log.actionType == EnumActionTypes.TriggerStageAlertTime
                  "
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info"
                        >Shakir Ansari</span
                      >
                      updated time alert
                      <span class="font-weight-bold text-purple"
                        >10M: 2H: 2D</span
                      >
                      from
                      <span class="font-weight-bold text-value"
                        >value id 01</span
                      >
                      to
                      <span class="font-weight-bold text-value"
                        >value id 02</span
                      >
                      to stage
                      <span class="font-weight-bold text-success"
                        >Stage 01</span
                      >
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="
                    log.actionType == EnumActionTypes.TriggerStageStepAlertTime
                  "
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info"
                        >Shakir Ansari</span
                      >
                      updated time alert
                      <span class="font-weight-bold text-purple"
                        >10M: 2H: 2D</span
                      >
                      from
                      <span class="font-weight-bold text-value"
                        >value id 01</span
                      >
                      to
                      <span class="font-weight-bold text-value"
                        >value id 02</span
                      >
                      to stage/step
                      <span class="font-weight-bold text-success"
                        >Stage 01</span
                      >
                      -
                      <span class="font-weight-bold text-success">Step 01</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 322"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated patient details
                      <span class="font-weight-bold text-danger">{{
                        log.fieldName
                      }}</span>
                      from
                      <span class="font-weight-bold text-data">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-data">{{
                        log.detailTextString
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == EnumActionTypes.updateCustomDemo"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated custom demo for
                      <span class="font-weight-bold text-demo"
                        >DID-{{ log.demoQuestIdIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.question
                      }}</span>
                      from
                      <span class="font-weight-bold text-response">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-response">{{
                        log.detailTextString
                      }}</span>
                      for
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>

                <div
                  v-else-if="log.actionType == EnumActionTypes.StageUpdateName"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated stage name from
                      <span class="font-weight-bold text-cyan">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-cyan">{{
                        log.stageName
                      }}</span>
                      <!-- to
                                                    <span class="font-weight-bold text-response">{{log.detailTextString}}</span>
                                                    for
                                                    <span class="font-weight-bold text-danger">{{log.ptId}}</span> 
                                                    -
                                                    <span class="font-weight-bold text-danger">{{log.firstName + " "+ log.lastName}}</span>-->
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 461"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated step name from
                      <span class="font-weight-bold text-response">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-demo">{{
                        log.detailTextString
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>

                <div
                  v-else-if="log.actionType == 8003"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned resource
                      <span class="font-weight-bold text-demo"
                        >R{{ log.detailTextString }}</span
                      >
                      for Visit ID
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 8010"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      reassigned resource
                      <span class="font-weight-bold text-demo"
                        >R{{ log.detailTextString }}</span
                      >
                      for Visit ID
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 8008"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      released resource
                      <span class="font-weight-bold text-demo"
                        >R{{ log.detailTextString }}</span
                      >
                      for Visit ID
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 415"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned task
                      <span class="font-weight-bold text-demo"
                        >TID-{{ log.taskCode }}</span
                      >
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.taskName
                      }}</span>
                      to stage
                      <span class="font-weight-bold text-response">{{
                        log.stageName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 416"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      Un-assigned task
                      <span class="font-weight-bold text-demo"
                        >TID-{{ log.taskCode }}</span
                      >
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.taskName
                      }}</span>
                      to stage
                      <span class="font-weight-bold text-response">{{
                        log.stageName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 457"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned task
                      <span class="font-weight-bold text-demo"
                        >TID-{{ log.taskCode }}</span
                      >
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.taskName
                      }}</span>
                      to stage/step
                      <span class="font-weight-bold text-response">{{
                        log.stageName
                      }}</span>
                      -
                      <span class="font-weight-bold text-response">{{
                        log.stepName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 458"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      Un-assigned task
                      <span class="font-weight-bold text-demo"
                        >TID-{{ log.taskCode }}</span
                      >
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.taskName
                      }}</span>
                      to stage/step
                      <span class="font-weight-bold text-response">{{
                        log.stageName
                      }}</span>
                      -
                      <span class="font-weight-bold text-response">{{
                        log.stepName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 417"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned resource
                      <span class="font-weight-bold text-demo"
                        >R{{ log.resourceIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.resourceName
                      }}</span>
                      <span v-if="log.fieldName == '1'">
                        as Capture to stage
                      </span>
                      <span v-else> as Release to stage </span>
                      <span class="font-weight-bold text-response">{{
                        log.stageName
                      }}</span>
                      <!-- -
                                                    <span class="font-weight-bold text-response">{{log.stepName}}</span> -->
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>

                <div
                  v-else-if="log.actionType == 418"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      un-assigned resource
                      <span class="font-weight-bold text-demo"
                        >R{{ log.resourceIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.resourceName
                      }}</span>
                      <span v-if="log.fieldName == '1'">
                        as Capture to stage
                      </span>
                      <span v-else> as Release to stage </span>
                      <span class="font-weight-bold text-response">{{
                        log.stageName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>

                <div
                  v-else-if="log.actionType == 459"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned resource
                      <span class="font-weight-bold text-demo"
                        >R{{ log.resourceIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.resourceName
                      }}</span>
                      <span v-if="log.fieldName == '1'">
                        as Capture to stage/Step
                      </span>
                      <span v-else> as Release to stage/Step </span>
                      <span class="font-weight-bold text-response">{{
                        log.stageName
                      }}</span>
                      -
                      <span class="font-weight-bold text-response">{{
                        log.stepName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>

                <div
                  v-else-if="log.actionType == 460"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      un-assigned resource
                      <span class="font-weight-bold text-demo"
                        >R{{ log.resourceIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.resourceName
                      }}</span>
                      <span v-if="log.fieldName == '1'">
                        as Capture to stage/Step
                      </span>
                      <span v-else> as Release to stage/Step </span>
                      <span class="font-weight-bold text-response">{{
                        log.stageName
                      }}</span>
                      -
                      <span class="font-weight-bold text-response">{{
                        log.stepName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>

                <div
                  v-else-if="log.actionType == 419"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated time alert
                      <span class="font-weight-bold text-demo">
                        Min, Hour, Days
                      </span>
                      from
                      <span class="font-weight-bold text-demo">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-response">{{
                        log.detailTextString
                      }}</span>
                      to stage
                      <span class="font-weight-bold text-response">{{
                        log.stageName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 462"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated time alert
                      <span class="font-weight-bold text-demo">
                        Min, Hour, Days
                      </span>
                      from
                      <span class="font-weight-bold text-demo">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-response">{{
                        log.detailTextString
                      }}</span>
                      to stage/Step
                      <span class="font-weight-bold text-response">{{
                        log.stageName
                      }}</span>
                      -
                      <span class="font-weight-bold text-response">{{
                        log.stepName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 410"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated order of stage
                      <span class="font-weight-bold text-cyan">{{
                        log.stageName
                      }}</span>
                      from
                      <span class="font-weight-bold text-order">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-order">{{
                        log.detailTextString
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 411"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned sms template
                      <span class="font-weight-bold text-demo">{{
                        log.smsTempIdSerial
                      }}</span>
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.smsTempName
                      }}</span>
                      to stage
                      <span class="font-weight-bold text-response">{{
                        log.stageName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 412"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      un-assigned sms template
                      <span class="font-weight-bold text-demo">{{
                        log.smsTempIdSerial
                      }}</span>
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.smsTempName
                      }}</span>
                      to stage
                      <span class="font-weight-bold text-response">{{
                        log.stageName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 413"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned email template
                      <span class="font-weight-bold text-demo"
                        >EID-{{ log.emailTempIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.emailTempName
                      }}</span>
                      to stage
                      <span class="font-weight-bold text-response">{{
                        log.stageName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 414"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      un-assigned email template
                      <span class="font-weight-bold text-demo"
                        >EID-{{ log.emailTempIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.emailTempName
                      }}</span>
                      to stage
                      <span class="font-weight-bold text-response">{{
                        log.stageName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 453"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned sms template
                      <span class="font-weight-bold text-demo"
                        >SMST-{{ log.smsTempIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.smsTempName
                      }}</span>
                      to stage/step
                      <span class="font-weight-bold text-response">{{
                        log.stageName
                      }}</span>
                      -
                      <span class="font-weight-bold text-response">{{
                        log.stepName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 454"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      un-assigned sms template
                      <span class="font-weight-bold text-demo"
                        >SMST-{{ log.smsTempIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.smsTempName
                      }}</span>
                      to stage/step
                      <span class="font-weight-bold text-response">{{
                        log.stageName
                      }}</span>
                      -
                      <span class="font-weight-bold text-response">{{
                        log.stepName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 455"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      assigned email template
                      <span class="font-weight-bold text-demo"
                        >EID-{{ log.emailTempIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.emailTempName
                      }}</span>
                      to stage/step
                      <span class="font-weight-bold text-response">{{
                        log.stageName
                      }}</span>
                      -
                      <span class="font-weight-bold text-response">{{
                        log.stepName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 456"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      un-assigned email template
                      <span class="font-weight-bold text-demo"
                        >EID-{{ log.emailTempIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.emailTempName
                      }}</span>
                      to stage/step
                      <span class="font-weight-bold text-response">{{
                        log.stageName
                      }}</span>
                      -
                      <span class="font-weight-bold text-response">{{
                        log.stepName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == releaseresourcepatient"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      released resource
                      <span class="font-weight-bold text-demo"
                        >R{{ log.resourceIdSerial }}</span
                      >
                      -
                      <span class="font-weight-bold text-demo">{{
                        log.resourceName
                      }}</span>
                      for Visit ID
                      <span class="font-weight-bold text-response">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-response">{{
                        log.dosStr
                      }}</span>
                      for
                      <span class="font-weight-bold text-response">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-response">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 463"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      Trigger for
                      <span class="font-weight-bold text-cyan">{{
                        log.stageName
                      }}</span>
                      -
                      <span class="font-weight-bold text-cyan">{{
                        log.stepName
                      }}</span>
                      time alert
                      <span class="font-weight-bold text-purple">{{
                        log.oldData
                      }}</span>
                      for
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId + "-"
                      }}</span>
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 420"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      Trigger for
                      <span class="font-weight-bold text-cyan">{{
                        log.stageName
                      }}</span>
                      time alert
                      <span class="font-weight-bold text-purple">{{
                        log.oldData
                      }}</span>
                      for
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId + "-"
                      }}</span>
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 421"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      Trigger for
                      <span class="font-weight-bold text-cyan"
                        >{{ log.stageName }}
                      </span>
                      time alert
                      <span class="font-weight-bold text-purple">{{
                        log.oldData
                      }}</span>
                      for
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId + "-"
                      }}</span>
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 465"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      Trigger for
                      <span class="font-weight-bold text-cyan"
                        >{{ log.stageName + "-" + log.stepName }}
                      </span>
                      time alert
                      <span class="font-weight-bold text-purple">{{
                        log.oldData
                      }}</span>
                      for
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId + "-"
                      }}</span>
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 464"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated order of step
                      <span class="font-weight-bold text-cyan">{{
                        log.stepName
                      }}</span>
                      from
                      <span class="font-weight-bold text-order"
                        >Order ID {{ log.oldData }}</span
                      >
                      to
                      <span class="font-weight-bold text-order"
                        >Order ID {{ log.detailTextString }}</span
                      >
                    </p>

                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 5010"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body" v-if="log.ptId == 0">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      left comment
                      <span class="font-weight-bold text-cyan">{{
                        log.detailTextString
                      }}</span>
                      for task
                      <span class="font-weight-bold text-task"
                        >TID-{{ log.tid }}</span
                      >
                      -
                      <span class="font-weight-bold text-task">{{
                        log.taskName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                  <div class="timeline-body" v-else>
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      left comment
                      <span class="font-weight-bold text-cyan">{{
                        log.detailTextString
                      }}</span>
                      for task
                      <span class="font-weight-bold text-task"
                        >TID-{{ log.tid }}</span
                      >
                      -
                      <span class="font-weight-bold text-task">{{
                        log.taskName
                      }}</span>
                      for visit id
                      <span class="font-weight-bold text-success">{{
                        log.vid
                      }}</span>
                      on DOS
                      <span class="font-weight-bold text-purple">{{
                        log.dosStr
                      }}</span>
                      for patient
                      <span class="font-weight-bold text-danger">{{
                        log.ptId
                      }}</span>
                      -
                      <span class="font-weight-bold text-danger">{{
                        log.patientName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <!-- Task Status Log -->
                <div
                  v-else-if="log.actionType == 9000"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      added Task Status
                      <span class="font-weight-bold text-task"
                        >{{ log.tsid }}</span
                      >
                      -
                      <span class="font-weight-bold text-task">{{
                        log.taskStatusName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 9001"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated Task Status
                      <span class="font-weight-bold text-task"
                        >{{ log.tsid }}</span
                      >
                      -
                      <span class="font-weight-bold text-task">{{
                        log.taskStatusName
                      }}</span>
                      for
                      <span class="font-weight-bold text-task">{{
                        log.fieldName
                      }}</span>
                      from
                      <span class="font-weight-bold text-data">{{
                        log.oldData
                      }}</span>
                      to
                      <span class="font-weight-bold text-data">{{
                        log.detailTextString
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 9002"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      updated order of Task Status
                      <span class="font-weight-bold text-task"
                        >{{ log.tsid }}</span
                      >
                      -
                      <span class="font-weight-bold text-task">{{
                        log.taskStatusName
                      }}</span>
                      from
                      <span class="font-weight-bold text-data"
                        >{{ log.oldData }}</span
                      >
                      to
                      <span class="font-weight-bold text-data">{{
                        log.detailTextString
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 9003"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      archived Task Status
                      <span class="font-weight-bold text-task"
                        >{{ log.tsid }}</span
                      >
                      -
                      <span class="font-weight-bold text-task">{{
                        log.taskStatusName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  v-else-if="log.actionType == 9004"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      activated Task Status
                      <span class="font-weight-bold text-task"
                        >{{ log.tsid }}</span
                      >
                      -
                      <span class="font-weight-bold text-task">{{
                        log.taskStatusName
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>

                <div
                  v-else-if="log.actionType == 10000"
                  class="timeline-panel history-panel"
                >
                  <div class="timeline-body">
                    <p>
                      <span class="font-weight-bold text-info">{{
                        log.userName
                      }}</span>
                      ran a mass update in the Task Module for the field
                      <span class="font-weight-bold text-demo"
                        >{{ log.fieldName }}</span
                      >
                      to new value
                      <span class="font-weight-bold text-order">{{
                        log.detailTextString
                      }}</span>
                    </p>
                    <p>
                      <small style="color: grey" class="mt-2"
                        >{{ log.dateLocalStr }} |
                        <span style="color: orangered">{{
                          log.practiceName
                        }}</span>
                        |
                        <span style="color: orangered"
                          >{{ log.appModelName }}
                        </span>
                      </small>
                    </p>
                  </div>
                </div>

                <!------------------------------------------- li end  -------------------------------------------------->
              </li>
              <li v-if="logs.length == 0" class="timeline-inverted history-li">
                <div class="timeline-badge history-badge danger">
                  <i class="fas fa-file"></i>
                </div>

                <div class="timeline-panel history-panel">
                  <div class="timeline-body">
                    <p>
                      <span
                        v-if="checking == true"
                        class="font-weight-bold text-danger"
                        >Fetching Record</span
                      >
                      <span v-else class="font-weight-bold text-danger"
                        >No Record Found</span
                      >
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import Multiselect from "@vueform/multiselect";

export default {
  name: "AuditLog",
  props: ["visitId", "patientId", "isModel", "notificationOnly"],

  data() {
    return {
      //loader
      checking: false,
      showSection: true,
      showUsers: true,
      //Timer
      TimerObject: {},
      actionsFiltered: [],
      logs: [],
      actionsRaw: [],
      dummy: [],
      selectedAppModelsId: [],
      appModelsList: [],
      selectedUsersId: [],
      usersList: [],
      EnumActionTypes: {
        UserLogin: 1000,
        CheckOut: 1,
        CheckOutRollBack: 2,

        EditVisitType: 50,
        EmailSent: 51,

        LeaveAComment: 100,

        Mapping: 200,
        MappingNewPatient: 201,

        PatientPaymentCollected: 300,
        PatientPaymentRequest: 301,
        PatientPaymentRefunded: 310,
        PatientPaymentReceipt: 313,
        PatientPaymentDeleted: 309,
        PatientPaymentColletedViaPortal: 315,
        PhysicianAssigned: 302,
        PhysicianReassigned: 303,
        PatientDetailUpdated: 304,
        PatientTypeReasonUpdated: 305,
        PatientPaymentReminder: 306,
        PatientReourceUpdated: 307,
        PatientPaymentStatusChanged: 308,
        PatientPaymentReconcile: 314,

        PatientCheckinViaForm: 311,
        PatientCheckinViaQuickCheckin: 312,

        //QuestionnaireUpdated : 600,

        //stage and step
        StepAcknowledgement: 400,
        //stage
        StageIntial: 401,
        StageChange: 402,
        StageAdd: 407,
        StageArchive: 408,
        StageUpdateName: 409,
        StageOrderUpdate: 410,
        AppointmentTime: 627,
        ChangeGroup: 628,
        //step
        StepStart: 403,
        StepClose: 404,
        StepRestart: 405,
        StepDelete: 406,
        StepAdd: 450,
        StepArchive: 412,
        StepActive: 413,
        StepOrderUpdate: 464,
        //step
        TextSent: 500,

        Location: 1000,
        PhysicianActive: 1001,
        PhysicianInactive: 1002,

        VisitTypeAdd: 2000,
        VisitTypeArchive: 2001,

        DemoAdd: 3000,
        DemoUpdate: 3001,
        DemoArchive: 3002,
        DemoActive: 3003,

        QuestionnaireAdd: 4000,
        QuestionnaireUpdate: 4001,
        QuestionnaireArchive: 4002,
        QuestionnaireActive: 4003,
        QuestionnaireAnswerChange: 4004,

        TaskAdd: 5000,
        TaskUpdate: 5001,
        TaskDelete: 5002,
        TaskAssignByUser: 5003,
        TaskAssign: 5004,
        TaskUnassign: 5005,
        TaskMarkCompleted: 5006,
        TaskTrigger: 5007,

        EmailTemplateSubmit: 6000,
        EmailTemplateUpdate: 6001,
        EmailTemplateDelete: 6002,
        EmailTemplateDraft: 6003,
        EmailSendTriggerStep: 6004,
        EmailSendTriggerStage: 6005,

        SMSTemplateAdd: 7000,
        SMSTemplateUpdate: 7001,
        SMSTemplateDelete: 7002,
        SmsTemplateDraft: 7003,
        SmsSendTriggerStep: 7004,
        SmsSendTriggerStage: 7005,

        ResourceAdd: 8000,
        ResourceUpdate: 8001,
        ResouceArchive: 8002,
        ResourceAssign: 8003,
        ResourceReleaseStep: 8004,
        ResourceCaptureStep: 8005,
        ResourceReleaseStage: 8006,
        ResourceCaptureStage: 8007,

        TaskStatusAdd:9000,
        TaskStatusUpdate:9001,
        TaskStatusOrder:9002,
        TaskStatusArchives:9003,
        TaskStatusActivates:9004,

        ActivePatientDelete: 318,
        InactivePatientDelete: 319,
        // Working on right now

        MassUpdateTaskStatus: 10000,
      },
      filterDate: "",
      VisitTaskId: 0,
      TaskId: 0,
    };
  }, //data

  methods: {
    //Timer
    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    getIcon(id) {
      //console.log(id);
      if (id == 100) return "assets/images/actions/comment.png";
      else if (id == 50) return "assets/images/actions/edit.png";
      else if (id == 51) return "assets/images/actions/sent.png";
      else if (id == 300) return "assets/images/actions/credit-card.png";
      else if (id == 302) return "assets/images/actions/stethoscope.png";
      else if (id == 303) return "assets/images/actions/stethoscope.png";
      else if (id == 201) return "assets/images/actions/mapping.png";
      else if (id == 301) return "assets/images/actions/cash-money.png";
      else if (id == 400) return "assets/images/actions/steps1.png";
      else if (id == 304) return "assets/images/actions/patient.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 50) return "assets/images/actions/edit.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 50) return "assets/images/actions/edit.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 50) return "assets/images/actions/edit.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 50) return "assets/images/actions/edit.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 50) return "assets/images/actions/edit.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
      // else if (id == 51) return "assets/images/actions/sent.png";
    },
    getFilterData() {
      this.intDummyComm();
      this.dummyComm.myDate = this.filterDate;
      this.dummyComm.extras = this.selectedUsersId.join();
      this.dummyComm.extras1 = this.selectedAppModelsId.join();

      const url = this.SERVER + "/VNSPRAAPI/actionlog/GetTimeline";

      this.axiosGetData(url, 2);
    },
    getTextdetail(log) {
      return log.detailTextString;
    },
    async getListFilters() {
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/ActionLog/GetUserList",
        data: this.dummyComm,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          //debugger// eslint-disable-line no-debugger
          // if everything goes well -- we will get data
          const response = res.data;
          if (response.status === true) {
            this.usersList = response.data.users;
            this.appModelsList = response.data.appmodels;
            this.filterDate = new Date().toISOString().substr(0, 10);
            if (this.filterDate !== response.data.myTime) {
              this.filterDate = response.data.myTime;
            }
            console.log();
          } else {
            console.log("");
          }
        })
        .catch(function (error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            alert("Error", error.message);
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
        });
    },
    ShowRecordFound() {
      if (this.logs.length < 1) this.checking = false;
    },
    loadInitNoFilter() {
      debugger;
      if (this.filterDate === "") {
        this.filterDate = new Date().toISOString().substr(0, 10);
      }
      this.intDummyComm();
      //debugger
      this.dummyComm.myDate = "";
      const url = this.SERVER + "/VNSPRAAPI/actionlog/GetTimeline";

      //this.loader_1();
      //this.getListFilters();
      this.axiosGetData(url, 1);
      this.StartLogoutTime();
    },
    loadInit() {
      debugger;
      if (this.filterDate === "") {
        this.filterDate = new Date().toISOString().substr(0, 10);
      }
      this.intDummyComm();
      //debugger
      this.dummyComm.myDate = "";
      const url = this.SERVER + "/VNSPRAAPI/actionlog/GetTimeline";

      //this.loader_1();
      this.getListFilters();
      this.axiosGetData(url, 1);
      this.StartLogoutTime();
    },
    loadInitNotification() {
      this.intDummyComm();
      //debugger
      this.dummyComm.myDate = "";
      this.dummyComm.Extras = "yes";
      const url = this.SERVER + "/VNSPRAAPI/actionlog/GetTimeline";

      //this.loader_1();
      this.axiosGetDataWithoutLoad(url, 1);
      this.StartLogoutTime();
    },
    loadInitPatient(PatientId) {
      this.showSection = false;
      this.showUsers = false;
      this.intDummyComm();
      //debugger
      this.filterDate = "";
      this.dummyComm.myDate = "";
      this.dummyComm.patientId = PatientId;

      const url = this.SERVER + "/VNSPRAAPI/actionlog/GetTimeline";
      //this.loader_1();
      this.logs = [];
      this.axiosGetData(url, 1);
      this.StartLogoutTime();
    },
    loadInitVisit(VisitId) {
      debugger;
      this.showSection = false;
      this.showUsers = false;
      this.intDummyComm();
      //debugger
      this.dummyComm.myDate = "";
      this.dummyComm.visitId = VisitId;

      const url = this.SERVER + "/VNSPRAAPI/actionlog/GetTimeline";
      //this.loader_1();
      this.logs = [];
      this.axiosGetData(url, 1);
      this.StartLogoutTime();
    },

    getAuditLogByVisitTaskIdAndTaskId(VisitId, visitTaskId, taskId) {
      debugger;
      this.showSection = false;
      this.showUsers = false;
      this.intDummyComm();
      //debugger
      this.dummyComm.myDate = "";
      this.dummyComm.visitId = VisitId;
      this.VisitTaskId = visitTaskId;
      this.TaskId = taskId;

      const url = this.SERVER + "/VNSPRAAPI/actionlog/GetTimeline";
      //this.loader_1();
      this.logs = [];
      this.axiosGetData(url, 1);
      this.StartLogoutTime();
    },

    //------------------------------------------ Common Methods
    async axiosGetDataWithoutLoad(myUrl, what) {
      this.intDummyComm();

      var UserIds = this.selectedUsersId.map((x) => x.id);
      var AppModalIds = this.selectedAppModelsId.map((x) => x.id);
      var DateFilter = false;
      if (this.filterDate !== "") {
        DateFilter = true;
        this.dummyComm.myDate = this.filterDate;
      }

      const myData = {
        DateFilter: DateFilter,
        UserIds: UserIds,
        AppModels: AppModalIds,
        dc: this.dummyComm,
      };
      this.checking = true;
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          //debugger// eslint-disable-line no-debugger
          // if everything goes well -- we will get data
          if (what === 1) {
            if (res.status === 200) {
              //console.log(res.data);
              const Data = res.data;
              if (Data.dc.auditFlag === 1) {
                this.logs = Data.logs;
              }
              //this.actionsRaw = res.data.visitHist;
            }
          } else if (what === 2) {
            if (res.status === 200) {
              //console.log(res.data);
              this.dummy = res.data;
              this.actionsFiltered = res.data.visitHist;
            }
          }
        })
        .catch(function (error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            alert("Error", error.message);
          }
        })
        .finally(() => {
          this.ShowRecordFound();
          this.ResetLogoutTime();
        });
    },
    // axiosGetData
    async axiosGetData(myUrl, what) {
      this.intDummyComm();
      debugger;
      var loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.auditLogRef,
        color: "#03a9f3",
      });
      var UserIds = this.selectedUsersId.map((x) => x.id);
      var AppModalIds = this.selectedAppModelsId.map((x) => x.id);
      var DateFilter = false;
      if (this.filterDate !== "") {
        DateFilter = true;
        this.dummyComm.myDate = this.filterDate;
      }
      const myData = {
        DateFilter: DateFilter,
        UserIds: UserIds,
        AppModels: AppModalIds,
        VisitTaskId: this.VisitTaskId,
        TaskId: this.TaskId,
        dc: this.dummyComm,
      };
      this.checking = true;
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          //debugger// eslint-disable-line no-debugger
          // if everything goes well -- we will get data
          if (what === 1) {
            if (res.status === 200) {
              //console.log(res.data);
              const Data = res.data;
              if (Data.dc.auditFlag === 1) {
                this.logs = Data.logs;
              }
              //this.actionsRaw = res.data.visitHist;
            }
          } else if (what === 2) {
            if (res.status === 200) {
              //console.log(res.data);
              this.dummy = res.data;
              this.actionsFiltered = res.data.visitHist;
            }
          }
        })
        .catch(function (error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            alert("Error", error.message);
          }
        })
        .finally(() => {
          this.ShowRecordFound();
          this.ResetLogoutTime();
          loader.hide();
        });
    }, // axiosGetData
    isItModel() {
      //debugger

      if (this.isModel !== undefined) return "margin-left: -40.7px;";
      else if (this.notificationOnly !== undefined) {
        return "margin-top:-8%; margin-left:-8%;margin-bottom:-10%";
      } else return "";
    },
  }, // methods

  mounted() {
    if (this.$store.getters.getAuthToken === "") {
      this.$store.commit("setAuthToken", localStorage.BeToken);
    }
    clearTimeout(this.loadObj);
    console.log("this is child component");
    //this.loadInit();
  }, // mounted
  unmounted() {
    clearTimeout(this.TimerObject);
  },
  watch: {
    patientId: function () {
      this.loadInit();
    },
    selectedUsersId: function () {
      console.log(this.selectedUsersId);
    },
    selectedAppModelsId: function () {
      console.log(this.selectedAppModelsId);
    },
    filterDate: function () {
      console.log(this.filterDate);
    },
  },
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.AuditMultiSelect {
  width: 100%;
}
.myStyleForCardBody {
  margin-top: -8% !important;
  margin-left: -8%;
}
.timeline {
  position: relative;
  padding: 20px 0 20px;
  list-style: none;
  max-width: 1600px;
  margin: 0 auto;
}

.timeline-margin {
  margin: 25px 0px 25px 35px !important;
}

.timeline:before {
  content: " ";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 3px;
  margin-left: -1.5px;
  background-color: #e9ecef;
}

.timeline-history:before {
  left: 1% !important;
}

.timeline > li {
  position: relative;
  margin-bottom: 20px;
}

.timeline > .history-li {
  margin-bottom: 0px !important;
}

.timeline > li:before,
.timeline > li:after {
  content: " ";
  display: table;
}

.timeline > li:after {
  clear: both;
}

.timeline > li:before,
.timeline > li:after {
  content: " ";
  display: table;
}

.timeline > li:after {
  clear: both;
}

.timeline > li > .history-panel {
  left: 30px !important;
  top: 8px !important;
  width: 100% !important;
  padding: 10px !important;
  border: 0px !important;
  -webkit-box-shadow: 0 1px 6px rgb(0 0 0 / 0%) !important;
  box-shadow: 0 1px 6px rgb(0 0 0 / 0%) !important;
}

.timeline > li > .timeline-panel {
  float: left;
  position: relative;
  width: 46%;
  padding: 20px;
  border: 1px solid #e9ecef;
  border-radius: 0.25rem;
  -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
}

.timeline > li > .timeline-panel:before {
  content: " ";
  display: inline-block;
  position: absolute;
  top: 26px;
  right: -8px;
  border-top: 8px solid transparent;
  border-right: 0 solid #e9ecef;
  border-bottom: 8px solid transparent;
  border-left: 8px solid #e9ecef;
}

.timeline > li > .timeline-panel:after {
  content: " ";
  display: inline-block;
  position: absolute;
  top: 27px;
  right: -7px;
  border-top: 7px solid transparent;
  border-right: 0 solid #fff;
  border-bottom: 7px solid transparent;
  border-left: 7px solid #fff;
}

.timeline > li > .timeline-badge {
  z-index: 10;
  position: absolute;
  top: 16px;
  left: 50%;
  width: 50px;
  height: 50px;
  margin-left: -25px;
  border-radius: 50% 50% 50% 50%;
  text-align: center;
  font-size: 1.4em;
  line-height: 50px;
  color: #fff;
  overflow: hidden;
}

.timeline > li > .history-badge {
  top: 10px !important;
  left: 1.5% !important;
  width: 40px !important;
  height: 40px !important;
  line-height: 40px !important;
}

.timeline > li.timeline-inverted > .timeline-panel {
  float: right;
}

.timeline > li.timeline-inverted > .timeline-panel:before {
  right: auto;
  left: -8px;
  border-right-width: 8px;
  border-left-width: 0;
}

.timeline > li.timeline-inverted > .timeline-panel:after {
  right: auto;
  left: -7px;
  border-right-width: 7px;
  border-left-width: 0;
}

.timeline-badge.primary {
  background-color: #fb9678;
}

.timeline-badge.success {
  background-color: #00c292;
}

.timeline-badge.warning {
  background-color: #fec107;
}

.timeline-badge.danger {
  background-color: #e46a76;
}

.timeline-badge.info {
  background-color: #03a9f3;
}

.timeline-title {
  margin-top: 0;
  color: inherit;
  font-weight: 400;
}

.timeline-body > p,
.timeline-body > ul {
  margin-bottom: 0;
}

.timeline-body > p + p {
  margin-top: 5px;
}

/*******************
Horizontal Timeline page
******************/
.cd-horizontal-timeline .events a {
  padding-bottom: 6px;
  color: #fb9678;
}

.cd-horizontal-timeline .filling-line,
.cd-horizontal-timeline .events a.selected::after {
  background: #fb9678;
}

.cd-horizontal-timeline .events a.selected::after {
  border-color: #fb9678;
}

.cd-horizontal-timeline .m-t-40 {
  margin-top: 40px !important;
}
.text-payment {
  color: #38761d !important;
}
.text-communication {
  color: #e40ec0 !important;
}
.text-question {
  color: #df7a11 !important;
}
.text-demo {
  color: #a68044 !important;
}
.text-task {
  color: #25a1a7 !important;
}
.text-resource {
  color: #557146 !important;
}
.text-value {
  color: #c90100 !important;
}
.text-total {
  color: #00ff4f !important;
}
.text-comment {
  color: #0014c2 !important;
}
.text-cyan {
  color: #01c0c8 !important;
}
.text-file {
  color: #6181b6 !important;
}
.text-order {
  color: #5f00ff !important;
}
.text-data {
  color: #d6cb0f !important;
}
</style>